module.exports = __webpack_public_path__ + "img/OMDAI.fe97c705.png";